import React from 'react';
import {
  QuestionContent,
  QuestionBaseContentData,
  QuestionChangeData,
} from './QuestionContent';
import { EmptyContent } from './base/EmptyContent';
import QuestionType from '@ax2/common/model/QuestionType';

export type EmptyQuestionData = QuestionBaseContentData & QuestionChangeData;

export const EmptyQuestion: React.FC<EmptyQuestionData> = props => {
  return (
    <QuestionContent
      {...props}
      questionContentElement={<EmptyContent />}
      answerContentElement={<EmptyContent />}
      preselectedType={QuestionType.Empty}
    />
  );
};
